export const public_url = '/bof-frontend-project-advanced'

type Role = 'admin' | 'customer'

export interface User{
    id: number
    email: string
    password: string
    name: string
    role: Role
    avatar: string
}

export interface Category{
    id: number
    name: string
    image: string
}

export interface Product{
    id: number
    title: string
    price: number
    description: string
    category: Category
    images: string[]
    isFavorite?: boolean
}

export interface CartItem{
    id: number
    product: Product
    count: number
}

interface LinkItem{
    id: string,
    value: string,
    path: string
}

export interface ILoginInputs {
    email: string
    password: string
}

export interface IRegisterInputs {
    name: string
    email: string 
    password: string
    confirmPassword: string
    avatar?: string
}

export const linkList: LinkItem[] = [
    {
        id: '',
        value: 'Home',
        path: '/'
    },
    {
        id: 'products',
        value: 'Products',
        path: '/products'
    },
    {
        id: 'about',
        value: "About",
        path: '/about'
    }
]

export interface FilterComponent{
    applyAction: CallableFunction
    products: Product[]
}